/**
 * Author:CC
 *
 * Time:2016-03-01
 */
'use strict';
angular.module('editNewspapaerUseSignedZPModule', [])
    .controller('editNewspaperUseSignedZPCtrl', ['$scope', '$state', '$modalInstance', '$validation', '$stateParams', '$filter', 'item', 'modalDialog', 'trsHttpService', 'trsspliceString', 'editingCenterService', 'options', 'editIsLock', '$element',
        function($scope, $state, $modalInstance, $validation, $stateParams, $filter, item, modalDialog, trsHttpService, trsspliceString, editingCenterService, options, editIsLock, $element) {
            initStatus();
            initData();

            /**
         * [initStatus description]
         *
         * @return  {[type]}  [return description]
         */
            function initStatus() {
                $scope.status = {
                    option: '',
                    selectedDieci: '',
                    selectedZhaopai: '',
                    isRequeted: false,
                    isShowPaperList: !!options.isFromResourceCenter,
                    selectedPaper: ''
                };
                $scope.data = {
                    items: item,
                    customConfig: {
                        singleDatePicker: true, // 是否是单选框
                    },
                    papaerList: []
                };
                $scope.data.curSiteId = $stateParams.paperid || $scope.data.items[0].SITEID;
            }

            /**
             * [initData description]
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                if (options.isFromResourceCenter) {
                    getSites().then((data) => {
                        if (data.DATA && data.DATA.length) {
                            $scope.data.papaerList = data.DATA;
                            if ($scope.data.papaerList.length) {
                                $scope.data.curSiteId = $scope.data.papaerList[0].SITEID;
                                $scope.status.selectedPaper = $scope.data.papaerList[0];
                                getDiecis();
                            } else {
                                modalDialog.alertType('', '没有可供签发照排的报纸', 'error', false);
                                $modalInstance.dismiss();
                            }
                        }
                    });
                } else {
                    getDiecis();
                }
                
                // 见报日期 以第一篇为根据，日期大于今天则默认第一篇的日期；小于今天的， 8点前默认今天，8点后默认第二天
                if (new Date($scope.data.items[0].PUBDATE).getTime() > new Date().getTime()){
	        		$scope.data.createDate = $scope.data.items[0].PUBDATE;
	        	} else {
	        		var date = new Date();
	                var nowHour = date.getHours();
	                date = (nowHour < 8) ? date : date.setDate(date.getDate() + 1);
	                $scope.data.createDate = $filter('date')(date, 'yyyy-MM-dd');
	        	}
            }

            /**
             * [getSites 获取纸媒报纸列表]
             *
             * @return  {[type]}  [return description]
             */
            function getSites() {
                return editingCenterService.querySitesByMediaType('3');
            }

            $scope.cancel = function() {
                $modalInstance.close(false);
            };

            /**
         * [reponseFilter description]过滤返回的reports
         * @param  {[obj]} elm [description]各个返回的report
         * @return {[null]}     [description]
         */
            $scope.reportsFilter = function(elm) {
                if (angular.isDefined(elm)) {
                    return elm.ISSUCCESS == 'false';
                }
            };

            /**
         * [successReportsFilter description]过滤返回的签发成功项
         * @param  {[obj]} elm [description]返回的report
         * @return {[type]}     [description]
         */
            $scope.successReportsFilter = function(elm) {
                if (angular.isDefined(elm)) {
                    return elm.ISSUCCESS == 'true';
                }
            };
            $scope.confirm = function() {
                $scope.status.isRequeted = true;
                $scope.data.createDate = $filter('date')($scope.data.createDate, 'yyyy-MM-dd').toString();
                var params = {
                    serviceid: 'mlf_paper',
                    methodname: options && options.methodname ? options.methodname : 'doQianFa',
                    SrcDocIds: trsspliceString.spliceString(item, 'METADATAID', ','),
                    BanMianID: $scope.status.selectedZhaopai.CHANNELID,
                    Option: $scope.status.option,
                    IsPaiChong: true,
                };
                params.pubdate = $scope.data.createDate;
                $validation.validate($scope.useSignedZPForm).success(function() {
                    if ($scope.status.selectedZhaopai === '') {
                        modalDialog.alertType('', '请先选择照排版面', 'warning', false);
                    } else {
                        if ($state.params.papermetadataid) { // 表示编辑页需要先解锁，因为保存后需要加一遍锁
                            editIsLock.normalLock($state.params.papermetadataid).then(() => {
                                doSign(params);
                            });
                        } else {
                            if (options.isFromResourceCenter) {
                                params.XHSGSourceIds = item.map((item) => item.id).join(',');
                                params.SourceName = options.sourceName || '';
                                params.PubDate = $scope.data.createDate;
                                delete params.SrcDocIds;
                                delete params.pubdate;
                            }
                            doSign(params);
                        }
                    // $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', true).then(function(data) {
                    //     modalDialog.multiReportsAlert(data, function() {
                    //         $modalInstance.close('success');
                    //     });
                    // }, function(data) {
                    //     if (data.status === '-1') {
                    //         modalDialog.alertType('签发失败', data.message, 'error', false);
                    //         return;
                    //     }
                    //     var temp = $filter('pick')(angular.copy(data.REPORTS), $scope.reportsFilter);
                    //     var successTemp = $filter('pick')(angular.copy(data.REPORTS), $scope.successReportsFilter);
                    //     var result = {
                    //         reports: temp,
                    //         params: params,
                    //         successReports: successTemp,
                    //         errorData: data
                    //     };
                    //     $modalInstance.close(result);
                    // });
                    }
                }).error(function() {
                    modalDialog.alertType('提交失败', '请输入正确的数据格式', 'error', false, function() {});
                });
            };

            /**
             * [doSign description] 执行签发
             * @param   {[object]}  params  [params description] 签发参数
             * @return  {[type]}            [return description]
             */
            function doSign(params){
                let isForbiddenError = !options.isFromResourceCenter;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get', isForbiddenError).then(function(data) {
                    modalDialog.multiReportsAlert(data, function() {
                        $modalInstance.close('success');
                    });
                }, function(data) {
                    if (data.status === '-1') {
                        modalDialog.alertType('签发失败', data.message, 'error', false);
                        return;
                    }
                    var temp = $filter('pick')(angular.copy(data.REPORTS), $scope.reportsFilter);
                    var successTemp = $filter('pick')(angular.copy(data.REPORTS), $scope.successReportsFilter);
                    var result = {
                        reports: temp,
                        params: params,
                        successReports: successTemp,
                        errorData: data
                    };
                    $modalInstance.close(result);
                });
            }

            /**
         * [getDiecis description]获取叠次列表
         *
         * @return  {[type]}  [return description]
         */
            function getDiecis() {
                var params = {
                    'serviceid': 'mlf_paper',
                    'methodname': 'queryDieCis',
                    'PaperId': $scope.data.curSiteId
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.dieciItems = data;
                    $scope.status.selectedDieci = data[0];
                    var params = {
                        'serviceid': 'mlf_paper',
                        'methodname': $scope.status.selectedPaper && $scope.status.selectedPaper.ISZHAOPAI === '0' ? 'queryCaiBianBanMians' : 'queryZhaoPaiBanMians',
                        'PaperId': $scope.data.curSiteId,
                        'DieCiId': $scope.status.selectedDieci.CHANNELID
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.data.zpItems = data;
                        $scope.status.selectedZhaopai = data[0];
                    });
                });
            }

            // 叠次选择切换相应的照排版面
            $scope.dieciClick = function(curItem, index) {
                $scope.status.selectedZhaopai = '';
                $scope.status.selectedDieci = curItem;
                getZPLayout();
            };

            /**
         * [getZPLayout description]根据叠次名获取照排版面列表
         *
         * @return  {[type]}  [return description]
         */
            function getZPLayout() {
                var params = {
                    'serviceid': 'mlf_paper',
                    'methodname': 'queryZhaoPaiBanMians',
                    'PaperId': $stateParams.paperid || $scope.data.items[0].SITEID,
                    'DieCiId': $scope.status.selectedDieci.CHANNELID
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.data.zpItems = data;
                });
            }

            // 选择照排版面,获取版面id
            $scope.zhaopaiClick = function(curItem, index) {
                $scope.status.selectedZhaopai = curItem;
            };

            $scope.paperClick = function(curItem) {
                $scope.status.selectedPaper = curItem;
                $scope.data.curSiteId = curItem.SITEID;
                getDiecis();
            };
        }]);
